import { render, staticRenderFns } from "./Highlights.vue?vue&type=template&id=16506903&scoped=true"
import script from "./Highlights.vue?vue&type=script&setup=true&lang=js"
export * from "./Highlights.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Highlights.vue?vue&type=style&index=0&id=16506903&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16506903",
  null
  
)

export default component.exports